// Copy for the prompt input itself, so both consumers (the empty-state starter and the pinned
// prompt bar) read it from the component they pass it to rather than from each other.

export const DASHBOARD_PROMPT_PLACEHOLDER = 'What info do you want to see on the dashboard?';

// U+21B5, matching the submit hint the Prism search field already ships (TertiaryNavigation).
export const DASHBOARD_PROMPT_SUBMIT_HINT = 'Press ↵';

// Label of the explicit submit button beside that hint. Enter stays the keyboard path; the button is
// the pointer path, so a user who clicked a template tile never has to reach for the keyboard.
export const DASHBOARD_PROMPT_SUBMIT_LABEL = 'Generate';

// Shown in place of the submit hint while the generate + save round trip is in flight, which takes
// several seconds against the model.
export const DASHBOARD_PROMPT_BUSY_HINT = 'Generating…';
